import { BASE_URL } from './Config.js';

export class MandatService {
  
  // 1. Récupérer tous les mandats
  fetchMandats = async () => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/all`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error("Erreur chargement mandats");
    return await response.json();
    };

  // 2. Récupérer un mandat spécifique avec ses lignes
  fetchMandat = async (id) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/${id}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error("Erreur chargement mandat");
    return await response.json();
  };

  // 3. Créer un nouveau mandat (avec ses lignes initiales)
  createMandat = async (mandatData) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/create`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify(mandatData)
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || "Erreur création mandat");
    }
    return await response.json();
  };

  // 4. Mettre à jour les infos du mandat (Client, etc.)
  updateMandat = async (id, mandatData) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/update/${id}`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify(mandatData)
    });
    if (!response.ok) throw new Error("Erreur mise à jour mandat");
    return await response.json();
  };

  // 5. Clôturer définitivement le mandat (et ses lignes)
  closeMandat = async (id) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/close/${id}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error("Erreur clôture mandat");
    return await response.json();
  };

  // 6. Ajouter une ligne au mandat (Déclenche l'attribution de stock)
  addProdToLine = async (mandatId, lineData) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/${mandatId}/addProdToLine`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(lineData)
    });
    if (!response.ok) {
      const errText = await response.text().catch(() => "Erreur inconnue");
      throw new Error(`Erreur HTTP ${response.status} : ${errText}`);
    }
    return await response.json();
  };

  removeLineFromMandat = async (lineId) => {
    const token = localStorage.getItem('accessToken');

   
    const response = await fetch(`${BASE_URL}/mandat/removeLine/${lineId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      const errText = await response.text().catch(() => "Erreur inconnue");
      throw new Error(`Erreur HTTP ${response.status} : ${errText}`);
    }
    return await response.text();
  };

  // remove prod from mandat line
  releaseProdFromLine = async (lineId) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/removeProdFromLine/${lineId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      const errText = await response.text().catch(() => "Erreur inconnue");
      throw new Error(`Erreur HTTP ${response.status} : ${errText}`);
    }
    return await response.text();
  };

    // 🟢 1. CRÉER une ligne de demande
 createLine = async (mandatId, lineData) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/${mandatId}/createLine`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(lineData)
    });
    if (!response.ok) {
      const errText = await response.text().catch(() => "Erreur inconnue");
      throw new Error(`Erreur HTTP ${response.status} : ${errText}`);
    }
    return await response.json();
  };

  updateAdresseLivraison = async (mandatId, addressId) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/mandat/${mandatId}/adresse-livraison/${addressId}`, {
      method: 'PUT',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error("Erreur enregistrement adresse de livraison");
    return await response.json();
  };


downloadPdf= async(mandatId) => {
  const token = localStorage.getItem('accessToken');

  return fetch(`${BASE_URL}/pdf/download-pdf-mandat/${mandatId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/pdf'
    }
  })
    .then(response => {
      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("Session expirée ou token invalide.");
        }

        if (response.status === 403) {
          throw new Error("Vous n'avez pas les droits pour télécharger ce PDF.");
        }

        if (response.status === 404) {
          throw new Error("Mandat introuvable.");
        }

        throw new Error(`Erreur téléchargement PDF (${response.status})`);
      }

      return response.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `mandat_${mandatId}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    });
}


}